import { render, staticRenderFns } from "./WarningBlock.vue?vue&type=template&id=3a4f2e1b&scoped=true&"
import script from "./WarningBlock.vue?vue&type=script&lang=js&"
export * from "./WarningBlock.vue?vue&type=script&lang=js&"
import style0 from "./WarningBlock.vue?vue&type=style&index=0&id=3a4f2e1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4f2e1b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a4f2e1b')) {
      api.createRecord('3a4f2e1b', component.options)
    } else {
      api.reload('3a4f2e1b', component.options)
    }
    module.hot.accept("./WarningBlock.vue?vue&type=template&id=3a4f2e1b&scoped=true&", function () {
      api.rerender('3a4f2e1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/WarningBlock.vue"
export default component.exports